import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import {
  selectVehiclesListOptions,
  setListOptions,
  selectVehiclesListStructure,
} from '@/features/domain/lists'
import { useEditingStateWithCtx } from '@/atoms'
import { useAppDispatch } from '@/store'

export function useSorter() {
  const listOptions = useSelector(selectVehiclesListOptions)
  const listStructure = useSelector(selectVehiclesListStructure)
  const { editing } = useEditingStateWithCtx('vehicle')
  const dispatch = useAppDispatch()

  const [field, setField] = useState(() => listOptions.sort[0].field)
  const [direction, setDirection] = useState(() => listOptions.sort[0].direction)

  useEffect(() => {
    if (!listOptions.sort) return
    if (listOptions.sort[0].field === field && listOptions.sort[0].direction === direction) return

    dispatch(
      setListOptions({
        category: 'unifiedVehicles',
        options: {
          ...listOptions,
          sort: [
            {
              field,
              direction,
            },
          ],
        },
      }),
    )
  }, [dispatch, field, direction, listOptions])

  return {
    editing,
    field,
    setField,
    direction,
    setDirection,
    noEntries: listStructure.totalItems === 0,
  }
}
